<template>
    <vs-table :data="data">
      <template slot="header" >
        <vs-row style="display:inline">
          <vs-col vs-w="2">
            <!-- <h3>
              {{ $tc('review_order',2)|capitalize}}
            </h3> -->
            <add-button @click="add" class="mt-3"/>
          </vs-col>

            <vs-col vs-offset="7" vs-w="3" style="display:inline-flex">
             <div class="con-input-search vs-table--search">
                <input
                  class="input-search vs-table--search-input"
                  type="text"
                  v-model="text"
                  @keypress.enter="search"
                />
                <vs-icon icon="search"></vs-icon>
              </div>
              <vs-button
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-filter"
                class="mx-2 mt-4"
                radius
                @click="openFilter"
              ></vs-button>
           </vs-col>            
        </vs-row>  
      </template>
      <template slot="thead">
        <!-- <th class="qb-sticky" :style="{background:'white'}"></th> -->
        <th-sort
          :text="$t('no_order') | capitalize"
          column="dwh_review_order.no_order"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$tc('type') | capitalize"
          column="IT.name"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('date') | capitalize"
          column="dwh_review_order.created_at"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('client') | capitalize"
          column="t1.ClientName"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('updated') | capitalize"
          column="dwh_review_order.updated_at"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('status') | capitalize"
          column="S.name"
          @sort="handleClickSort"
        />
        <th class="qb-sticky">
          {{ $t('actions') }}
        </th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            {{ data[i].no_order }}
          </vs-td>
           <vs-td>
            {{ data[i].invoice_type }}
          </vs-td>
           <vs-td>
            {{ formatDate(data[i].created_at)	 }}
          </vs-td>
           <vs-td>
            {{ data[i].ClientName }}
          </vs-td>
           <vs-td>
            {{ formatDate(data[i].updated_at) }}
          </vs-td>
           <vs-td>
           <vs-chip :color="data[i].color.toString().trim()">
             {{ data[i].status_name }}
           </vs-chip>
          </vs-td>
          <vs-td>
            <div>
            <action-icon
              icon="ArrowRightCircleIcon"
              :tooltip="$t('details')"
              @click="showDetails(data[i].id)"
            />
               <!-- <action-pdf-viewer :files="[data[i].file]"/> -->
              <!-- <action-icon icon="EditIcon" :tooltip="$t('edit')" />
              <action-icon icon="FileIcon" :tooltip="$t('file')" /> -->
            </div>
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import mixins from '@/mixins'
import AddButton from '@/views/components/buttons/AddButton'
export default {
  components: {
    ActionIcon,
    ThSort,
    AddButton,
  },
  data: () => ({
    text: '',
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    add(e) {
      this.$emit('add', e)
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'review-order-filter')
    },
    showDetails(id) {
      this.$router.push({
        name: 'review-order-details',
        params: {
          id: id,
        },
      })
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>